
const routes = {
    error: '*',
    illustration: {
        term: '/illustration/term',
        ci: '/illustration/ci',
    },
};

export default routes;
